// Copyright ©️ 2026 eVolve MEP, LLC

import { Stack, Title, Anchor } from '@mantine/core';

import { EvolveIcon } from 'assets/icons/EvolveIcon';
import { useEvolveNavigate } from 'components/Mantine/Navigation/useEvolveNavigate';

export const MobileRestricted = () => {
  const navigate = useEvolveNavigate('', true);
  const goBack = () => navigate(-1);
  return (
    <Stack c="#b1b2b3" w="100%" h="91vh" justify="center" align="center" p="xl">
      <EvolveIcon icon="Info" size="xl" />
      <Title order={3} ta="center">
        This page is not supported on mobile.
      </Title>
      <Title order={4} ta="center">
        Switch to a larger display to view content, or{' '}
        <Anchor className="link" onClick={goBack}>
          go back to the previous page.
        </Anchor>
      </Title>
    </Stack>
  );
};
